export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <article className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/e8a0f646da1c2cc5823e222bbbb63a18.jpg')`
        }}
        role="img"
        aria-label="Modern luxury real estate office interior in Granada and Costa del Sol"
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 text-center">
        <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Your Trusted Partner in<br /><strong>Real Estate Excellence</strong>
        </h2>
        <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
          From <strong>property search</strong> to professional <strong>property management</strong>, we provide comprehensive <strong>real estate services in Granada and Costa del Sol, Spain</strong>
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a 
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              scrollToContact();
            }}
            className="group relative bg-teal-600 text-white px-10 py-4 rounded-lg text-lg font-semibold overflow-hidden transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span className="absolute inset-0 bg-gradient-to-r from-teal-700 to-teal-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
            <span className="relative flex items-center gap-2">
              Get In Touch
              <i className="ri-arrow-right-line transform group-hover:translate-x-1 transition-transform duration-300"></i>
            </span>
          </a>
          <a 
            href="#services"
            onClick={(e) => {
              e.preventDefault();
              const element = document.getElementById('services');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="group relative bg-white/10 backdrop-blur-sm text-white px-10 py-4 rounded-lg text-lg font-semibold overflow-hidden transition-all duration-300 border-2 border-white/30 hover:bg-white/20 hover:border-white/50 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span className="absolute inset-0 bg-white/10 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
            <span className="relative flex items-center gap-2">
              Our Services
              <i className="ri-service-line transform group-hover:rotate-12 transition-transform duration-300"></i>
            </span>
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/70" aria-hidden="true"></i>
      </div>
    </article>
  );
}
